import { assemblyOperationsOfferedBy } from "../bench-work/plan-operations";
import { ToolType } from "../Tool";

/**
 * The starter tool: every new shop opens with one mounted on the workspace.
 * Nailed joinery lives here — recipes that need a hammer are hammer
 * operations, so a station without one simply can't offer them. Which
 * builds those are is a fact of each plan record (`offeredBy: "hammer"`
 * in src/game/plans/).
 */
export const hammer: ToolType = {
  id: "hammer",
  name: "Hammer",
  description:
    "A 16 oz claw hammer. Nailed assembly is only available at a station with one mounted.",
  cost: 12,
  // A hand tool belongs on a bench, not clamped into a jointer's jig slot.
  compatibleMachines: ["workspace", "worktable1x1", "worktable1x2"],
  operations: assemblyOperationsOfferedBy("hammer"),
};
